export const INTERNAL_VIEWPORT = Object.freeze({
  width: 384,
  height: 216,
});

export interface ViewportLayout {
  readonly scale: number;
  readonly width: number;
  readonly height: number;
  readonly offsetX: number;
  readonly offsetY: number;
}

export function calculateViewportLayout(screenWidth: number, screenHeight: number): ViewportLayout {
  if (!Number.isFinite(screenWidth) || !Number.isFinite(screenHeight)) {
    throw new TypeError("Viewport dimensions must be finite numbers.");
  }

  if (screenWidth <= 0 || screenHeight <= 0) {
    throw new RangeError("Viewport dimensions must be positive.");
  }

  const scale = Math.floor(
    Math.min(screenWidth / INTERNAL_VIEWPORT.width, screenHeight / INTERNAL_VIEWPORT.height),
  );

  if (scale < 1) {
    throw new RangeError("Viewport is smaller than the minimum supported internal resolution.");
  }

  const width = INTERNAL_VIEWPORT.width * scale;
  const height = INTERNAL_VIEWPORT.height * scale;

  return {
    scale,
    width,
    height,
    offsetX: Math.floor((screenWidth - width) / 2),
    offsetY: Math.floor((screenHeight - height) / 2),
  };
}
